import { render, staticRenderFns } from "./CreateNewMasterLevel.vue?vue&type=template&id=9a84f434"
import script from "./CreateNewMasterLevel.vue?vue&type=script&lang=js"
export * from "./CreateNewMasterLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports